'use client';
import Image from "next/image";
import Link from "next/link";
import styles from "@/app/styles/performers.module.scss";
import useDeviceType from "@/app/utils/useDeviceType";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Carousel } from 'react-bootstrap';
import https from "https";
import { useState, useEffect } from "react";
import CodeDisplay from "@/app/utils/content";
import Loading from "./loading";

const agent = new https.Agent({
  rejectUnauthorized: false,
});

async function getPageData() {
  const query = `
{
  pageData: pageBy(id: "cG9zdDoxMDc3") {
    pageBan {
      bannerText
      bannerSlider {
        desktopImage {
          node {
            mediaItemUrl
          }
        }
      }
    }
    content
    performance {
      overviewCreativeHeading
      overviewText
      overviewTitleH1Heading
      performanceDownload {
        node {
          mediaItemUrl
        }
      }
    }
  }
  qlperformers {
    nodes {
      performers {
        performerCountry
        performerDescription
        selectIfFeaturedPerformer
        performerImage {
          node {
            mediaItemUrl
          }
        }
        performerfeatureImage {
          node {
            mediaItemUrl
          }
        }
      }
      title
      content
      slug
    }
  }
}
  `;

  const res = await fetch(
    `${process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT}`,
    {
      httpsAgent: agent,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({query}),
      next: {
        revalidate: 60,
      },
    }
  );

  const { data } = await res.json();

  return data;
}

export default function Performance() {

  const deviceType = useDeviceType();

  const [page_banner_text, setPageBannerText] = useState("");
  const [page_banner_sliders, setPageBannerSliders] = useState([]);

  const [page_content, setPageContent] = useState(null);

  const[overwiew_creativeHeader,setovCreativeHeader] = useState("");
  const[overwiew_Text,setoverviewText] = useState("");
  const[overwiew_Title,setoverviewTitleH1Heading] = useState("");
  const[performer_Menu,setperformersImge] = useState("");

  const [Performers,setPerformers] = useState([]);

  const [pre_loader_enabled, setPreLoaderEnable] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const page = await getPageData();
      if(page){
       // console.log(page);
        if(page.pageData){

          if(page.pageData.pageBan){
            if(page.pageData.pageBan.bannerText){
              setPageBannerText(page.pageData.pageBan.bannerText);
            }
            if(page.pageData.pageBan.bannerSlider){
              setPageBannerSliders(page.pageData.pageBan.bannerSlider);
            }
          }
          if(page.pageData.content){
            setPageContent(page.pageData.content);
          }
          if (page.pageData.performance) {
            if (page.pageData.performance.overviewCreativeHeading) {
                setovCreativeHeader(page.pageData.performance.overviewCreativeHeading);
            }
            if (page.pageData.performance.overviewText) {
                setoverviewText(page.pageData.performance.overviewText);
            }
            if (page.pageData.performance.overviewTitleH1Heading) {
                setoverviewTitleH1Heading(page.pageData.performance.overviewTitleH1Heading);
            }  
            if (page.pageData.performance.performanceDownload) {
                if (page.pageData.performance.performanceDownload.node) {
                    if (page.pageData.performance.performanceDownload.node.mediaItemUrl) {
                        setperformersImge(page.pageData.performance.performanceDownload.node.mediaItemUrl)
                    }
                }
            }          
          }

          if(page.qlperformers){
            if(page.qlperformers.nodes){
              setPerformers(page.qlperformers.nodes);
            }
          }
        }
        setPreLoaderEnable(false);
      }
    };

    fetchData();
    return () => {};
  }, []);


  useEffect( () => {
    (
      async () => {
          const LocomotiveScroll = (await import('locomotive-scroll')).default
          const locomotiveScroll = new LocomotiveScroll();
      }
    )()
  }, [])

  if (pre_loader_enabled) {
    return <Loading />;
  }

  return (
    <>
        {page_banner_sliders && page_banner_sliders.length !== 0 &&(
            <section className="inner-banner position-relative">
                <Carousel fade className='page-inner-carousel'>
                {page_banner_sliders.map((banner_img, index) => {

                let imgurl = '';

                if(banner_img.desktopImage){
                    if(banner_img.desktopImage.node){
                    if(banner_img.desktopImage.node.mediaItemUrl){
                        imgurl = banner_img.desktopImage.node.mediaItemUrl;
                    }
                    }
                }

                return(
                <Carousel.Item key={index}>
                    <Image
                    className={styles.banner_section_main_img}
                    src={imgurl}
                    width={deviceType !== "mobile" ? 1920 : 400}
                    height={deviceType !== "mobile" ? 1080 : 800}
                    alt="Banner Image"
                    priority
                    quality={deviceType !== "mobile" ? 50 : 80}
                    />
                </Carousel.Item>
                );}
                )}
                </Carousel>
                <div className='inner-banner-text'>
                <h2 className='all-caps section-heading-large section-heading--yellow'>{page_banner_text}</h2>
                </div>
            </section>
        )}
        {page_banner_sliders && page_banner_sliders.length === 0 &&(
            <section className="bg-dark-green green-mesh  inner-banner-text-wrap position-relative">
                <div className='inner-banner-text z-top'>
                <h1 className='all-caps section-heading section-heading--yellow m-0 heading-padding'>{page_banner_text}</h1>
                </div>
            </section>
        )}
        {page_content &&(
            <section className="section-padding-bottom bg-dark-green green-mesh ">
                <div className="middle-wrap z-top middle-wrap-single">
                <div className="the_content_div">
                    <CodeDisplay code={page_content} />
                </div>
                </div>
            </section>
        )}

        <section className={`${styles.overwiewSec} section-padding-top section-padding-bottom bg-dark-meroon green-mesh`} >
            <div className="middle-wrap">
                <div className={`${styles.wraperOverwiew} d-flex wraperOverwiew`}>
                    <div className={styles.leftOverwiew}>
                        <h6 className="creativeheader creative-heading-small creative-heading--white wraperOverwiewh6">
                            {overwiew_creativeHeader}
                        </h6>
                        <h1 className="section-heading paragraph--whiteTxt tab-text-left all-caps">
                            {overwiew_Title}
                        </h1>
                    </div>
                    <div className={styles.rightOverwiew}>
                        <p className="paragraph paragraph--white paraRiOver">
                            {overwiew_Text}
                        </p>
                        <div className={styles.downloadOverPerform}>
                            {performer_Menu &&(
                                <div className='z-top button-menu'>
                                    <a
                                        target="_blank"
                                        className={`${styles.performer_Menu}`}
                                        href={performer_Menu}
                                    >
                                        <div className={`all-caps ${styles.span_performer_Menu}`} >download performance calendar</div>
                                        <div><Image
                                        src="/down-arr-w.png"
                                        width={15}
                                        height={10}
                                        alt="Down arrow"
                                        /></div>
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>

        
        <section className={`section-padding-bottom bg-dark-meroon green-mesh`}>
            <div className="middle-wrap">
                <div className={styles.featurePerformer}>
                    <div className={styles.featureImageMain}>
                    {Performers.map((performers_item, index) => {
                            let imgurl = "";
                            let Featureimgurl = "";
                            let country = "";
                            let Description = "";
                            let checkPerformer = "";
                            let titleP = "";
                            let contentD = "";

                            if (performers_item.performers) {
                                if (performers_item.performers.performerCountry) {
                                    country = performers_item.performers.performerCountry;
                                }
                                if (performers_item.performers.performerDescription) {
                                    Description = performers_item.performers.performerDescription;
                                }
                                if (performers_item.performers.selectIfFeaturedPerformer) {
                                  checkPerformer = performers_item.performers.selectIfFeaturedPerformer;
                                }
                                if (performers_item.performers.performerImage){
                                  if (performers_item.performers.performerImage.node) {
                                      if (performers_item.performers.performerImage.node.mediaItemUrl) {
                                        imgurl = performers_item.performers.performerImage.node.mediaItemUrl;
                                      }
                                  }
                                }
                                if (performers_item.performers.performerfeatureImage){
                                  if (performers_item.performers.performerfeatureImage.node) {
                                      if (performers_item.performers.performerfeatureImage.node.mediaItemUrl) {
                                        Featureimgurl = performers_item.performers.performerfeatureImage.node.mediaItemUrl;
                                      }
                                  }
                                }
                            }
                            if (performers_item.title) {
                              titleP = performers_item.title;
                            }
                            if (performers_item.content) {
                              contentD = performers_item.content;
                            }

                            if (checkPerformer) {
                              return(
                                <div className={styles.featureImage_div} key={index}>
                                  <div className={`${styles.fImage_boxx} dish_boxImage`}>
                                    <div className={`position-relative ${styles.performWrap}`}>
                                      <Link href={`/sin-performer/${performers_item.slug}`} className={styles.performers_item_slug}>
                                        <Image
                                          className={styles.ImagePerformCollect}
                                          src={Featureimgurl}
                                          width={deviceType !== "mobile" ? 1460 : 1000}
                                          height={deviceType !== "mobile" ? 778 : 600}
                                          alt="Banner Image"
                                          quality={deviceType !== "mobile" ? 100 : 80}
                                        />
                                        <div className={`${styles.peform_feature_text} position-absolute`}>
                                            <h3 className={styles.featuretext}>featured performer</h3>
                                            <div className={styles.wrapBotmData}>
                                              <h2 className={styles.titleP}>{titleP} / <span className={styles.country}>{country}</span></h2>
                                              <div className={styles.Description}>{Description}</div>
                                              <div><hr className={styles.hrLine}></hr></div>
                                              <div className={`${styles.wrapDetailBodyBx} d-flex`}>
                                                  <div className={styles.contentD}><CodeDisplay code={contentD} /></div>
                                                  <div className={`${styles.btn_profile} all-caps`}>
                                                    <Link href={`/sin-performer/${performers_item.slug}`} className={`${styles.profilea} next-btn next-btn--white`}>
                                                      View Profile
                                                      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18" fill="none">
                                                        <path d="M1 1L9 9.00018L1 17" stroke="white" strokeWidth="2"/>
                                                      </svg>
                                                    </Link>
                                                  </div>
                                              </div>
                                            </div>
                                        </div>
                                      </Link>
                                    </div>                            
                                  </div>
                                </div>
                              );
                            }
                            
                    })}
                        
                    </div>
                </div>            
            </div>               
        </section>

        <section className={`section-padding-bottom bg-dark-meroon green-mesh`}>
            <div className="middle-wrap">
                <div className={styles.featurePerformer}>
                    <div className={styles.featureImage}>
                      {Performers.map((performers_item, index) => {
                        let imgurl = "";
                        let Featureimgurl = "";
                        let country = "";
                        let Description = "";
                        let checkPerformer = "";
                        let titleP = "";
                        let contentD = "";

                        if (performers_item.performers) {
                            if (performers_item.performers.performerCountry) {
                                country = performers_item.performers.performerCountry;
                            }
                            if (performers_item.performers.performerDescription) {
                                Description = performers_item.performers.performerDescription;
                            }
                            if (performers_item.performers.selectIfFeaturedPerformer) {
                              checkPerformer = performers_item.performers.selectIfFeaturedPerformer;
                            }
                            if (performers_item.performers.performerImage){
                              if (performers_item.performers.performerImage.node) {
                                  if (performers_item.performers.performerImage.node.mediaItemUrl) {
                                    imgurl = performers_item.performers.performerImage.node.mediaItemUrl;
                                  }
                              }
                            }
                            if (performers_item.performers.performerfeatureImage){
                              if (performers_item.performers.performerfeatureImage.node) {
                                  if (performers_item.performers.performerfeatureImage.node.mediaItemUrl) {
                                    Featureimgurl = performers_item.performers.performerfeatureImage.node.mediaItemUrl;
                                  }
                              }
                            }
                        }
                        if (performers_item.title) {
                          titleP = performers_item.title;
                        }
                        if (performers_item.content) {
                          contentD = performers_item.content;
                        }

                        if (!checkPerformer) {

                        return(
                          <div className={styles.party_box} key={index}>
                            <div className={styles.party_box_inner}>
                              <Link href={`/sin-performer/${performers_item.slug}`} className={styles.performers_item_slug}>
                                  <Image
                                    className={styles.ImagePerformCollect}
                                    src={imgurl}
                                    width={deviceType !== "mobile" ? 710 : 1000}
                                    height={deviceType !== "mobile" ? 770 : 600}
                                    alt="Banner Image"
                                    quality={deviceType !== "mobile" ? 100 : 80}
                                  />
                                  <div className={styles.party_box_inner_title}>
                                    <div>
                                      <h2 className={`${styles.titleP} ${styles.partyTitle}`}>{titleP} / <span className={styles.country}>{country}</span></h2>
                                    </div>
                                  </div>
                                  <div className={styles.party_box_inner_content}>
                                    <div className={styles.party_box_inner_content_inner}>
                                      <h2 className={`${styles.titleP} ${styles.partyTitle}`}>{titleP} / <span className={styles.country}>{country}</span></h2>
                                      <p className={`${styles.Description}`}>{Description}</p>
                                      <div><hr className={styles.hrLine}></hr></div>
                                      <div className={`${styles.btn_profile} all-caps`}>
                                          <Link href={`sin-performer/${performers_item.slug}`} className={`${styles.profilea} next-btn next-btn--white`}>
                                            View Profile
                                            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18" fill="none">
                                              <path d="M1 1L9 9.00018L1 17" stroke="white" strokeWidth="2"/>
                                            </svg>
                                          </Link>
                                        </div>
                                    </div>
                                  </div>
                                </Link>
                            </div>
                          </div>
                        );
                      }
                      })}
                    </div>
                </div>            
            </div>               
        </section>



    </>
  )
}
